export default __webpack_public_path__ + "static/bg-clocks-71af5693b384245d8d857693aba4e557.webp";